(() => {
let $7bec22ef1ef4818f$var$lastKnownScrollPosition = 0;
let $7bec22ef1ef4818f$var$ticking = false;
function $7bec22ef1ef4818f$var$initPlayer() {
    const playerContainer = document.getElementById("player");
    const playerLinks = document.querySelectorAll("[data-player]");
    document.getElementById("player-close")?.addEventListener("click", (event)=>{
        event.preventDefault();
        playerContainer.innerHTML = "";
    });
    playerLinks.forEach((playerLinkElement)=>{
        playerLinkElement.addEventListener("click", (event)=>{
            playerContainer.innerHTML = "";
            event.preventDefault();
            const playerIframeContent = playerLinkElement.querySelector("[data-player-content]")?.textContent || "";
            playerContainer.innerHTML = playerIframeContent;
        });
    });
}
function $7bec22ef1ef4818f$var$init() {
    $7bec22ef1ef4818f$var$initPlayer();
    document.addEventListener("scroll", (event)=>{
        $7bec22ef1ef4818f$var$lastKnownScrollPosition = window.scrollY;
        if (!$7bec22ef1ef4818f$var$ticking) {
            window.requestAnimationFrame(()=>{
                $7bec22ef1ef4818f$var$ticking = false;
            });
            $7bec22ef1ef4818f$var$ticking = true;
        }
    });
}
document.addEventListener("DOMContentLoaded", $7bec22ef1ef4818f$var$init);

})();
//# sourceMappingURL=main.js.map
